import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a76342b8295d5001422b1f3_1787498632347_3ef26e8b/clingyai/src/app/privacy-policy/page.tsx");
